<template>
  <div id="drawer-truck-information" class="drawer drawer-right drawer-map-right dw-xs-10 fold"
       aria-labelledby="drawer-truck-information" aria-expanded="true" style="">
    <div class="drawer-contents">
      <div class="drawer-heading">
        <h3 class="drawer-title">
          <i class="fa fa-truck"></i> Truck Information
          <a href="#drawer-truck-information" data-toggle="drawer" aria-controls="drawer-shortlist" class="btn btn-primary pull-right">
            <i class="fa fa-times"></i>
          </a>
        </h3>
      </div><!-- /.drawer-heading -->
      <div class="drawer-body">
        <template v-if="get(value, 'load')">
          <div class="thumb-left truck m-b-sm">
            <img :src="truck.url" class="thumb" alt="truck">
            <h3 class="m-b-none">{{ truck.company }}</h3>
            <p>{{ truck.registration }}</p>
          </div><!-- /.thumb-left -->

          <p class="text-muted small">Location last updated {{ get(value, 'location.age') }}.</p>

          <p class="material-details">
            <strong>{{ get(value, 'load.carrier.name') }}</strong><br>
            {{ get(value, 'load.carrier.company') }}<br>
            <i class="fa fa-phone" :style="{visibility: get(value, 'load.carrier.mobile') ? 'visible' : 'hidden'}"></i> <a :href="`tel:${get(value, 'load.carrier.mobile')}`">{{ get(value, 'load.carrier.mobile') }}</a>
          </p>

          <p class="material-details">
            <strong>Base Location</strong><br>
            {{ truck.location }}
          </p>

          <p class="material-details">
            <strong>Primary Driver</strong><br>
          </p>

          <div class="thumb-left m-b-md">
            <img :src="get(truck, 'driver.url')" class="thumb">
            <h3 class="m-b-none">{{ get(truck, 'driver.name') }}</h3>
            <i class="fa fa-mobile"></i>
            <a :href="`tel:${get(truck, 'driver.mobile')}`">{{ get(truck, 'driver.mobile') }}</a>
          </div><!-- /.thumb-left -->

          <h3 class="m-b-md m-t-lg"><i class="fa fa-info-circle text-muted"></i> Active Load Details</h3>

          <div class="job-details">
            <h4>{{ get(value, 'load.job.client') }}</h4>
            <p>{{ `${get(value, 'load.job.number')} - ${get(value, 'load.job.quantity')}t ${get(value, 'load.job.commodity.name')}` }}</p>
            <router-link target="_blank" :to="{ name: 'loads.show', params: { id: get(value, 'load.id') }}">
              <i class="fa fa-external-link"></i>
            </router-link>
          </div>

          <job-location :location="get(value, 'load.from')" title="From"></job-location>

          <job-location :location="get(value, 'load.to')" title="To"></job-location>

          <router-link target="_blank" :to="{ name: 'loads.show', params: { id: get(value, 'load.id') }}">
            View load history.
          </router-link>
        </template>
        <template v-else>
          <div class="thumb-left m-b-md">
            <img :src="get(value, 'url')" class="thumb" alt=""/>
            <h3 class="m-b-none">{{ get(value, 'name') }}</h3>
            <i class="fa fa-mobile" :style="{visibility: get(value, 'mobile') ? 'visible' : 'hidden'}"></i> <a :href="`tel:${get(value, 'mobile')}`">{{ get(value, 'mobile') }}</a>
          </div><!-- /.thumb-left -->
          <p></p>

          <p class="text-muted small">
            Location last updated {{ get(value, 'location.age') }}.
          </p>

          <h3 class="m-b-sm m-t-lg"><i class="fa fa-info-circle text-muted"></i> No Active Load</h3>

          <router-link target="_blank" :to="{ name: 'loads.show', params: { id: get(value, 'load.id') }}">
            View load history.
          </router-link>
        </template>
      </div><!-- /.drawer-body -->
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import { get } from 'lodash'
import moment from 'moment'
import JobLocation from './JobLocation'

export default {
  props: ['value'],

  components: {
    JobLocation
  },

  data () {
    return {
      thumbnail_url: null
    }
  },

  watch: {
    value (value) {
      if (value === null) {
        $(this.$el).drawer('hide')
      } else {
        $(this.$el).drawer('show')
      }
    }
  },

  computed: {
    thumbnailUrl () {
      if (this.value.photo_storage_path) {
        return `${this.value.photo_storage_path}/256x256.jpg?${moment().unix()}`
      }

      return null
    },

    truck () {
      if (this.value && this.value.trucks && this.value.trucks.length) {
        return this.value.trucks[0]
      }

      return { driver: {} }
    }
  },

  methods: {
    get,

    handleClose () {
      this.$emit('input', null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TruckDetails.vue?512e1037